import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { translation } from "../locales/en";



const resources = {
	"en": { translation: translation }
}

i18n
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources: resources, //loadLocaleMessages(),
		debug: true,
		lng: "en",
		interpolation: {
			escapeValue: false // react already safes from xss
		}
	});

export default i18n;
